var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { EmphasisEnum } from "../../enums";
var ToggleWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  font-size: 1rem;\n  width: calc(3rem + 2ch);\n"], ["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  font-size: 1rem;\n  width: calc(3rem + 2ch);\n"])));
var ToggleCircle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isOn = _a.isOn, theme = _a.theme;
    return "\n    position: absolute;\n    height: 1rem;\n    width: 1rem;\n    border-radius: 50%;\n    background-color: ".concat(theme.white(), ";\n    left: ").concat(isOn ? "calc(100% - 1rem)" : "0", ";\n    transition: all 1s;\n  ");
});
var ToggleContent = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isOn = _a.isOn, theme = _a.theme;
    return "\n    position: relative;\n    display: flex;\n    align-items: center;\n    height: 1rem;\n    width: 35px;\n    background-color: ".concat(isOn ? theme[EmphasisEnum.success]() : theme.bgDisabled(), ";\n    border-radius: 0.8rem;\n    border: 2px solid ").concat(theme.borderInput(0.2), ";\n  ");
});
var ToggleText = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    color: ".concat(theme.colorContent(), ";\n    font-size: 0.8rem;\n    margin-left: 5px;\n  ");
});
var ToggleInput = function (_a) {
    var onText = _a.onText, offText = _a.offText, value = _a.value, onChange = _a.onChange;
    var _b = useState(value), currValue = _b[0], setValue = _b[1];
    var handleClick = useCallback(function () {
        var nextValue = !currValue;
        setValue(nextValue);
        if (onChange) {
            onChange(nextValue);
        }
    }, [currValue, onChange]);
    var handleKeyPress = useCallback(function (event) {
        if (event.code === "Space") {
            handleClick();
        }
    }, [handleClick]);
    return (React.createElement(ToggleWrapper, { tabIndex: 1, onClick: handleClick, onKeyPress: handleKeyPress },
        React.createElement(ToggleContent, { isOn: currValue },
            React.createElement(ToggleCircle, { isOn: currValue })),
        React.createElement(ToggleText, null, currValue ? onText : offText)));
};
export default ToggleInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
